<template>
  <form @submit.prevent>
    <div class="field">
      <label for="" class="label">Email</label>
      <div class="control has-icons-left">
        <input
          v-model="email"
          type="email"
          placeholder="e.g. bobsmith@gmail.com"
          class="input"
          required
        />
        <span class="icon is-small is-left">
          <font-awesome-icon :icon="['fa', 'envelope']" />
        </span>
      </div>
    </div>
    <div class="field">
      <label for="" class="label">Password</label>
      <div class="control has-icons-left">
        <input
          v-model="password"
          type="password"
          placeholder="*******"
          class="input"
          required
        />
        <span class="icon is-small is-left">
          <font-awesome-icon :icon="['fa', 'lock']" />
        </span>
      </div>
    </div>
    <div class="field">
      <button class="button ps-button is-fullwidth" @click="signUp">
        Register
      </button>
    </div>
    <div class="is-flex">
      <input v-model="emailMarketing" type="checkbox" />
      <span
        class="is-size-7 mb-1 has-text-grey-dark ml-2"
        data-test="terms-agreement"
      >
        We'd love to send you exclusive offers and news about Pedalsure. You can
        ask us to stop at any time. If you would prefer not to hear from us,
        please tick the box.
      </span>
    </div>
  </form>
</template>

<script>
/* eslint-disable no-console */
import { mapActions } from 'vuex'
import { auth } from '~/services/firebase'

export default {
  name: 'RegisterForm',
  middleware: ['handle-login-route'],
  props: {
    redirectUrl: {
      type: String,
      default: '/dashboard',
    },
  },
  data() {
    return {
      email: '',
      password: '',
      emailMarketing: false,
    }
  },
  methods: {
    ...mapActions('user', ['login']),
    async signUp() {
      try {
        const firebaseUser = await auth.createUserWithEmailAndPassword(
          this.email,
          this.password
        )
        // await this.writeUserData(firebaseUser.uid, firebaseUser.email)
        await this.login({
          data: firebaseUser,
          emailMarketing: this.emailMarketing,
        })

        // TODO IF exisiting customer redirect to dashboard
        // this.$router.push('/dashboard')
        this.$router.push({
          path: this.redirectUrl,
          query: { ...this.$route.query },
        })
        this.$gtm.push({
          event: 'register',
          provider: 'emailpassword',
        })
      } catch (error) {
        console.log(error)
        this.$toast.clear()
        this.$toast.error('The email already exist')
      }
    },
  },
}
</script>
